module.exports = __webpack_public_path__ + "static/media/book2.28b116d6.svg";